<script setup lang="ts">
import { useTheme } from 'vuetify'
import { useThemeConfig } from '@/composable/useThemeConfig'
import { useAppStore } from '@/stores/app'

const appStore = useAppStore()

const { currentTheme, getNextThemeName, getNextThemeIcon } = useThemeConfig()

appStore.setTheme(currentTheme.value)

const vuetifyTheme = useTheme()

function changeTheme() {
  currentTheme.value = getNextThemeName()

  appStore.setTheme(currentTheme.value)

  vuetifyTheme.global.name.value = currentTheme.value
}
</script>

<template>
  <VBtn
    icon
    variant="text"
    color="default"
    size="small"
    class="mr-1 theme-switcher"
    @click="changeTheme"
  >
    <VIcon
      :icon="getNextThemeIcon()"
      size="24"
    />
  </VBtn>
</template>

<style lang="scss" scoped>
.theme-switcher {
  width: 2rem !important;
  height: 2rem !important;
}
</style>
